import { GridFilterModel, GridLogicOperator } from '@mui/x-data-grid';
import { createSlice } from '@reduxjs/toolkit';

export const filterSlice = createSlice({
    name: 'filter',
    initialState: {
        filterModel: { items: [], logicOperator: GridLogicOperator.And } as GridFilterModel,
        tableEditAllowed: false,
        tableEditable: false,
        gridView: 'undefined' as 'grid' | 'list' | 'undefined',
    },
    reducers: {
        setStoredFilterModel: (state, action) => {
            state.filterModel = action.payload;
        },
        setTableEditAllowed: (state, action) => {
            state.tableEditAllowed = action.payload;
        },
        setTableEditable: (state, action) => {
            state.tableEditable = action.payload;
        },
        setGridView: (state, action) => {
            state.gridView = action.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setStoredFilterModel, setTableEditAllowed, setTableEditable, setGridView } = filterSlice.actions

export const getStoredFilterModel = (state: any) => state.filter.filterModel as GridFilterModel
export const getTableEditAllowed = (state: any) => state.filter.tableEditAllowed as boolean
export const getTableEditable = (state: any) => state.filter.tableEditable as boolean
export const getGridView = (state: any) => state.filter.gridView as 'grid' | 'list' | 'undefined'

export default filterSlice.reducer